// extracted by mini-css-extract-plugin
export var closeButton = "_75-0";